import React from "react";
import {
  Box,
  Typography,
  CardContent,
  List,
  ListItem,
  ListItemText,
  ListItemIcon,
  Divider,
} from "@mui/material";
import { StyledCard } from "../../common/StyledCard";
import { getEntityMeta } from "../../../helpers/dashboardHelpers";
import GradeIcon from "@mui/icons-material/Grade";
import { TimetableSlotStatsDto } from "../../../shared/dtos/timetableSlot/TimetableSlotStatsDto";

interface TimetableSlotOverviewWidgetProps {
  data: TimetableSlotStatsDto;
}

const TimetableSlotOverviewWidget: React.FC<
  TimetableSlotOverviewWidgetProps
> = ({ data }) => {
  const meta = getEntityMeta("TIMETABLE_SLOT");
  const Icon = meta.icon;
  const topTeachers = data.topTeachersByLessonCount || [];

  return (
    <StyledCard sx={{ height: "100%" }}>
      <CardContent>
        <Box sx={{ display: "flex", alignItems: "center", mb: 2 }}>
          <Box
            sx={{
              p: 1,
              borderRadius: 1,
              bgcolor: `${meta.color}15`,
              color: meta.color,
              display: "flex",
              mr: 2,
            }}
          >
            <Icon />
          </Box>
          <Typography variant="h6" sx={{ fontWeight: "bold" }}>
            {meta.title}
          </Typography>
        </Box>

        <Box sx={{ my: 3, textAlign: "center" }}>
          <Typography variant="body2" sx={{ color: "text.secondary" }}>
            Total Scheduled Lessons
          </Typography>
          <Typography variant="h4" sx={{ fontWeight: "bold" }}>
            {data.totalScheduledLessons}
          </Typography>
        </Box>

        <Divider sx={{ my: 2 }} />

        <Box>
          <Typography variant="body2" sx={{ color: "text.secondary", mb: 1 }}>
            Top Teachers by Lesson Count
          </Typography>
          {topTeachers.length > 0 ? (
            <List dense sx={{ maxHeight: 120, overflowY: "auto" }}>
              {topTeachers.map((teacher, index) => (
                <ListItem key={index} disablePadding>
                  <ListItemIcon sx={{ minWidth: 35 }}>
                    <GradeIcon color="action" fontSize="small" />
                  </ListItemIcon>
                  <ListItemText
                    primary={
                      <Typography variant="body2" sx={{ fontWeight: "bold" }}>
                        {teacher.name}
                      </Typography>
                    }
                    secondary={
                      <Typography
                        variant="caption"
                        sx={{ color: "text.secondary" }}
                      >
                        {teacher.lessonCount} lessons
                      </Typography>
                    }
                  />
                </ListItem>
              ))}
            </List>
          ) : (
            <Typography variant="caption" sx={{ color: "text.disabled" }}>
              No scheduled lessons yet.
            </Typography>
          )}
        </Box>
      </CardContent>
    </StyledCard>
  );
};

export default TimetableSlotOverviewWidget;
